import React from 'react';
import authLeftBg from '../images/coverbg.jpg';
import LinearLoading from './reuse/LinearLoading';
import { useGetApiLoading } from '../hooks/useLoadingState';

function AuthLayout({ children }) {
  const isGetApiLoading = useGetApiLoading();
  
  return (
    <div style={{ minHeight: '100vh', display: 'flex', background: '#0b0f19' }}>
      {/* Global Linear Loading Bar for GET APIs */}
      <LinearLoading show={isGetApiLoading} />
      {/* Left image panel */}
      <div
        className="auth-left"
        style={{
          flexBasis: '50%',
          position: 'relative',
          display: 'block',
          overflow: 'hidden',
        }}
      >
        <img
          src={authLeftBg}
          alt="Auth background"
          onError={(e) => {
            e.currentTarget.style.display = 'none';
            e.currentTarget.parentElement.style.background =
              'radial-gradient(1200px 500px at -10% 20%, rgba(76,29,149,0.55) 0%, rgba(11,15,25,0) 60%), radial-gradient(1000px 400px at 120% 80%, rgba(20,184,166,0.55) 0%, rgba(11,15,25,0) 60%), linear-gradient(180deg, #0b0f19 0%, #0b0f19 100%)';
          }}
          style={{
            position: 'absolute',
            inset: 0,
            width: '100%',
            height: '100%',
            objectFit: 'cover',
          }}
        />
        {/* top-left logo text */}
        <div style={{ position: 'absolute', top: 18, left: 20, color: '#ffffff', fontWeight: 800, fontSize: 20 }}>
          Admin AgentZena
        </div>
        {/* bottom-left slogan */}
        {/* <div style={{ position: 'absolute', left: 24, bottom: 24, color: '#ffffff', fontWeight: 700, fontSize: 18 }}>
          Experience the future of automation with Agent Zena.
        </div> */}
      </div>

      {/* Right form panel with subtle gradient */}
      <div
        className="auth-right"
        style={{
          flexBasis: '50%',
          maxWidth: '100%',
          marginLeft: 'auto',
          background: '#1d283a',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div className="auth-card" style={{ width: 480, maxWidth: '90%', padding: 36, color: '#94a3b8' }}>
          {children}
        </div>
      </div>
      <style>{`
        @media (max-width: 899px) {
          .auth-left { display: none !important; }
          .auth-right { flex-basis: 100% !important; }
          .auth-card { width: 92vw !important; padding: 24px !important; }
        }
        @media (min-width: 900px) {
          .auth-right { flex-basis: 50% !important; }
        }
      `}</style>
    </div>
  );
}

export default AuthLayout;


